module.exports = ["az önce","%s saniye önce","%s dakika önce","%s saat önce","%s gün önce","%s hafta önce","%s ay önce","%s yıl önce"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-timeago/locales/tr-TR.json
// module id = Kdpc
// module chunks = 1